(function(){
  if (window.__rarelySmartSearchBound) return;
  window.__rarelySmartSearchBound = true;

  var UCP_PROFILE_URL = 'https://shopify.dev/ucp/agent-profiles/examples/2026-04-08/valid-with-capabilities.json';
  var ucpRequestSeq = 0;

  function norm(value) {
    return String(value || '').toLowerCase().replace(/[^a-z0-9$]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  var synonymMap = {
    wife: 'gift home hosting premium', husband: 'gift outdoor edc grooming', mom: 'gift home kitchen cozy', dad: 'gift outdoor edc cooking',
    host: 'hosting kitchen home cook', hostess: 'hosting kitchen home cook', apartment: 'first apartment home kitchen storage',
    wedding: 'wedding gift housewarming kitchen home', housewarming: 'housewarming gift home kitchen',
    backpack: 'bag rucksack travel commute', rucksack: 'backpack bag travel', duffle: 'duffel bag weekend travel',
    toolbox: 'toolbox storage steel box organizer', blue: 'blue indigo navy', green: 'green olive moss', cook: 'cooking kitchen chef knife cast iron',
    cooking: 'cook kitchen chef knife cast iron', camping: 'camp outdoor bushcraft field trail', camp: 'camping outdoor bushcraft field trail',
    cheap: 'under 50 under 100', affordable: 'under 50 under 100', small: 'small gift under 50', desk: 'office notebook analog organizer'
  };

  function expandQuery(query) {
    var parts = norm(query).split(' ').filter(Boolean);
    var expanded = parts.slice();
    parts.forEach(function(part) {
      if (synonymMap[part]) expanded = expanded.concat(synonymMap[part].split(' '));
    });
    return expanded.filter(function(token, index, array) { return token.length > 1 && array.indexOf(token) === index; });
  }

  function scoreProduct(product, tokens, rawQuery) {
    var text = product.x || '';
    var title = norm(product.t);
    var handle = norm(String(product.h || '').replace(/-/g, ' '));
    var signals = product.s || '';
    var score = Number(product.b || 0);
    tokens.forEach(function(token) {
      if (title.indexOf(token) !== -1) score += 24;
      if (handle.indexOf(token) !== -1) score += 18;
      if (text.indexOf(token) !== -1) score += 8;
      if (signals.indexOf(token) !== -1) score += 18;
    });
    var phrase = norm(rawQuery);
    if (phrase && text.indexOf(phrase) !== -1) score += 45;
    var underMatch = phrase.match(/under\s*\$?(\d+)/);
    if (underMatch) score += product.pc <= Number(underMatch[1]) * 100 ? 35 : -80;
    if (/in stock|available|ships now/.test(phrase)) score += product.a ? 25 : -100;
    if (/\b(camping|camp|outdoor|trail|bushcraft)\b/.test(phrase) && /\b(gear|equipment|kit|essentials|camping|camp)\b/.test(phrase)) {
      var gearText = title + ' ' + handle + ' ' + text + ' ' + signals;
      ['gear', 'clip', 'firestarter', 'fire', 'hatchet', 'axe', 'knife', 'bushcraft', 'kettle', 'cookset', 'lantern', 'fishing', 'handline', 'rucksack', 'backpack', 'chair', 'boot', 'glove', 'tool'].forEach(function(term) {
        if (gearText.indexOf(term) !== -1) score += 38;
      });
      if (/\b(soap|body wash|fragrance|t-shirt|shirt|tank|scarf|apron|tonic|repellent)\b/.test(gearText)) score -= 75;
      if (/\b(camp soap|bug repellent)\b/.test(gearText)) score += 24;
      if (/\b(sold out)\b/.test(gearText)) score -= 100;
    }
    if (!product.a) score -= 35;
    return score;
  }

  function productCard(product, index) {
    var img = product.i ? '<img src="' + escapeHtml(imageUrl(product.i, 800)) + '" alt="' + escapeHtml(product.alt || product.t) + '" width="400" height="400" loading="' + (index < 4 ? 'eager' : 'lazy') + '">' : '';
    return '<a class="product-item rarely-smart-search-card" href="' + escapeHtml(product.u) + '" data-smart-search-handle="' + escapeHtml(product.h) + '">' +
      '<div class="product-item-image">' + img + '</div>' +
      '<div class="product-item-info">' +
        '<span class="product-item-title">' + escapeHtml(product.t) + '</span>' +
        '<p class="product-item-desc">' + escapeHtml(product.v || 'Rarely pick') + '</p>' +
      '</div>' +
    '</a>';
  }

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function(char) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[char];
    });
  }

  function imageUrl(url, width) {
    if (!url) return '';
    if (/([?&])width=/.test(url)) return url;
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
  }

  function stripHtml(value) {
    return String(value || '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function truncate(value, length) {
    value = String(value || '').trim();
    return value.length > length ? value.slice(0, length - 1).trim() + '…' : value;
  }

  function centsToMoney(cents, currency) {
    var amount = Number(cents || 0) / 100;
    try {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', maximumFractionDigits: amount % 1 ? 2 : 0 }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(amount % 1 ? 2 : 0);
    }
  }

  function numericVariantId(gid) {
    var match = String(gid || '').match(/(\d+)$/);
    return match ? match[1] : '';
  }

  function requestedMaxCents(rawQuery) {
    var match = norm(rawQuery).match(/under\s*\$?\s*(\d+)/);
    return match ? Number(match[1]) * 100 : null;
  }

  function normalizeCatalogProduct(product, rawQuery) {
    var variants = Array.isArray(product.variants) ? product.variants : [];
    var variant = variants.filter(function(item) { return item && item.availability && item.availability.available; })[0] || variants[0] || {};
    var price = (variant.price && variant.price.amount) || (product.price_range && product.price_range.min && product.price_range.min.amount) || 0;
    var currency = (variant.price && variant.price.currency) || (product.price_range && product.price_range.min && product.price_range.min.currency) || 'USD';
    var max = requestedMaxCents(rawQuery);
    if (max != null && Number(price || 0) > max) return null;
    var media = (variant.media && variant.media[0]) || (product.media && product.media[0]) || {};
    var description = stripHtml((product.description && product.description.html) || (variant.description && variant.description.html) || '');
    var handle = product.handle || (product.url ? String(product.url).split('/products/')[1] : '') || '';
    if (handle.indexOf('?') !== -1) handle = handle.split('?')[0];
    return {
      h: handle,
      t: product.title || 'Rarely product',
      u: product.url || (handle ? '/products/' + handle : '/search?q=' + encodeURIComponent(rawQuery || '')),
      v: truncate(description || (variant.title ? 'Variant: ' + variant.title : 'Live catalog match'), 123),
      p: centsToMoney(price, currency),
      pc: Number(price || 0),
      i: media.url || '',
      alt: product.title || '',
      a: !!(variant.availability && variant.availability.available),
      vid: numericVariantId(variant.id),
      x: norm([product.title, handle, description, variant.title, (product.tags || []).join(' ')].join(' ')),
      s: norm([(product.collections || []).map(function(c) { return c.title; }).join(' '), (product.tags || []).join(' ')].join(' ')),
      b: 8
    };
  }

  function extractCatalogProducts(payload) {
    var structured = payload && payload.result && payload.result.structuredContent;
    if (!structured && payload && payload.result && payload.result.content && payload.result.content[0] && payload.result.content[0].text) {
      try { structured = JSON.parse(payload.result.content[0].text); } catch (e) {}
    }
    return structured && Array.isArray(structured.products) ? structured.products : [];
  }

  function hasMeaningfulTokenMatch(product, tokens) {
    var stop = { gift: true, gifts: true, for: true, someone: true, under: true, cheap: true, affordable: true, small: true };
    var meaningful = (tokens || []).filter(function(token) { return token && !stop[token] && !/^\d+$/.test(token); });
    if (!meaningful.length) return true;
    var text = [product.t, product.h, product.x, product.s].join(' ');
    return meaningful.some(function(token) { return text.indexOf(token) !== -1; });
  }

  function liveCatalogSearch(query) {
    if (!query || norm(query).length < 2 || !window.fetch) return Promise.resolve([]);
    if (/\b(camping|camp|outdoor|trail|bushcraft)\b/.test(norm(query)) && /\b(gear|equipment|kit|essentials)\b/.test(norm(query))) return Promise.resolve([]);
    var payload = {
      jsonrpc: '2.0',
      method: 'tools/call',
      id: Date.now(),
      params: {
        name: 'search_catalog',
        arguments: {
          meta: { 'ucp-agent': { profile: UCP_PROFILE_URL } },
          catalog: {
            query: query,
            context: {
              address_country: 'US',
              currency: 'USD',
              language: 'en-US',
              intent: 'Customer is searching Rarely for: ' + query
            },
            filters: { available: true },
            pagination: { limit: 8 }
          }
        }
      }
    };
    return fetch('/api/ucp/mcp', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    }).then(function(response) {
      if (!response.ok) throw new Error('UCP search failed');
      return response.json();
    }).then(function(data) {
      var seen = {};
      var tokens = expandQuery(query);
      return extractCatalogProducts(data).map(function(product) { return normalizeCatalogProduct(product, query); })
        .filter(function(product) {
          if (!product || !product.a || !product.h || seen[product.h] || !hasMeaningfulTokenMatch(product, tokens)) return false;
          seen[product.h] = true;
          return true;
        }).slice(0, 8);
    }).catch(function() { return []; });
  }

  function rank(query) {
    var index = window.RarelySmartSearchIndex;
    if (!index || !Array.isArray(index.p)) return [];
    var tokens = expandQuery(query);
    if (!tokens.length) {
      return index.p.filter(function(product) { return product.a; }).slice(0, 8);
    }
    return index.p.map(function(product) {
      return { product: product, score: scoreProduct(product, tokens, query) };
    }).filter(function(row) { return row.score > 18; })
      .sort(function(a, b) { return b.score - a.score; })
      .map(function(row) { return row.product; })
      .slice(0, 8);
  }

  function renderProducts(mount, query, picks) {
    if (!picks.length) {
      mount.hidden = true;
      mount.innerHTML = '';
      return;
    }
    var headline = query ? 'Recommended for “' + escapeHtml(query) + '”' : 'Popular picks';
    mount.innerHTML = '<div class="rarely-smart-search__header"><h2>' + headline + '</h2></div><div class="products-grid rarely-smart-search__grid">' + picks.map(productCard).join('') + '</div>';
    mount.hidden = false;
  }

  function render() {
    var mount = document.getElementById('rarely-smart-search-results');
    if (!mount) return;
    var nativeGrid = document.getElementById('search-products-grid');
    if (nativeGrid && nativeGrid.querySelector('.product-item')) {
      mount.hidden = true;
      mount.innerHTML = '';
      return;
    }
    var input = document.querySelector('.search-page-input[name="q"]');
    var params = new URLSearchParams(window.location.search);
    var query = input && input.value ? input.value : (params.get('q') || '');
    if (mount.getAttribute('data-smart-query') === query && mount.innerHTML) return;
    mount.setAttribute('data-smart-query', query);
    var picks = rank(query);
    renderProducts(mount, query, picks);
    var seq = ++ucpRequestSeq;
    liveCatalogSearch(query).then(function(livePicks) {
      if (seq !== ucpRequestSeq || !livePicks.length) return;
      renderProducts(mount, query, livePicks);
    });
  }

  document.addEventListener('DOMContentLoaded', render);
  if (document.readyState !== 'loading') render();

  document.addEventListener('click', function(event) {
    var btn = event.target.closest('.rarely-smart-search-add');
    if (!btn) return;
    var handle = btn.getAttribute('data-handle');
    var variantId = btn.getAttribute('data-variant-id');
    if (!handle && !variantId) return;
    var original = btn.textContent;
    btn.disabled = true;
    btn.textContent = 'Adding…';
    Promise.resolve().then(function() {
      if (variantId) return variantId;
      return fetch('/products/' + handle + '.js')
        .then(function(response) { return response.json(); })
        .then(function(product) {
        var variant = (product.variants || []).find(function(item) { return item.available; }) || (product.variants || [])[0];
        if (!variant) throw new Error('No variant found');
        return variant.id;
      });
    }).then(function(id) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });
      })
      .then(function(response) {
        if (!response.ok) throw new Error('Cart add failed');
        btn.textContent = 'Added!';
        return fetch('/cart.js').then(function(response) { return response.json(); }).catch(function() { return null; });
      })
      .then(function(cart) {
        var badge = document.querySelector('#cart-badge');
        if (badge && cart) badge.textContent = cart.item_count;
        var drawerBtn = document.querySelector('cart-drawer-component button[on\\:click="/open"]');
        if (drawerBtn) setTimeout(function() { drawerBtn.click(); }, 250);
        setTimeout(function() { btn.disabled = false; btn.textContent = original; }, 1500);
      })
      .catch(function() {
        btn.disabled = false;
        btn.textContent = 'View details';
        window.location.href = '/products/' + handle;
      });
  });
})();
